import { BrowserRouter } from 'react-router-dom'
import { AnalyticsProvider } from '@/providers/AnalyticsProvider'
import { MainLayout } from '@/layouts/MainLayout'
import { AppRoutes } from '@/routes'

function App() {
  return (
    <BrowserRouter>
      <AnalyticsProvider>
        <MainLayout>
          <AppRoutes />
        </MainLayout>
      </AnalyticsProvider>
    </BrowserRouter>
  )
}

export default App
